import { defineComponent, ref } from "vue";
import IconButton from "../common/base/IconButton.vue.mjs";
import InviteIcon from "../common/icons/InviteIcon.vue.mjs";
import { useBasicStore } from "../../stores/basic.mjs";
import { storeToRefs } from "pinia";
import { useI18n } from "../../locales/index.mjs";
import "../../services/main.mjs";
import { roomService } from "../../services/roomService.mjs";
import "@tencentcloud/tuiroom-engine-js";
import { isMobile } from "../../utils/environment.mjs";
import "mitt";
import "../../services/manager/roomActionManager.mjs";
import "@tencentcloud/tui-core";
import Index from "../RoomInvite/index.mjs";
import "../../directives/vClickOutside.mjs";
const _sfc_main = /* @__PURE__ */ defineComponent({
  __name: "InviteControl",
  emits: ["show-overlay"],
  setup(__props, { emit }) {
    const isShowInviteTab = ref(false);
    const inviteRef = ref();
    const basicStore = useBasicStore();
    const { sidebarName } = storeToRefs(basicStore);
    const { t } = useI18n();
    const inviteControlConfig = roomService.getComponentConfig("InviteControl");
    function toggleInviteSidebar() {
      isShowInviteTab.value = !isShowInviteTab.value;
      if (isMobile) {
        if (basicStore.sidebarName === "invite") {
          basicStore.setSidebarName("");
          return;
        }
        basicStore.setSidebarName("invite");
        emit("show-overlay", {
          name: "RoomInviteOverlay",
          visible: isShowInviteTab.value
        });
      }
      roomService.trackingManager.sendMessage("experience-invite");
    }
    function handleClickOutSide() {
      if (isShowInviteTab.value) {
        isShowInviteTab.value = false;
      }
    }
    return { __sfc: true, isShowInviteTab, inviteRef, basicStore, sidebarName, t, emit, inviteControlConfig, toggleInviteSidebar, handleClickOutSide, IconButton, InviteIcon, roomInvite: Index, isMobile };
  }
});
export {
  _sfc_main as default
};
